import{useSelector}from'react-redux';const useAppState=()=>{return useSelector(state=>state.app);};export default useAppState;